import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import { Link } from "react-router-dom";
const BreadcrumbComponent = (props)=>{
   
return(
<section className={Style.clear + " "+Style.breadcrumb}>
    <Container>
    <Row>
        <Col>
            <ul>
                <li><Link to="/">{props.home} </Link></li>
                <li>{props.listOne}</li>
               {props.listTwo && <li>{props.listTwo}</li>}
            </ul>
        </Col>
    </Row>
    </Container>
</section>
)
}
export default BreadcrumbComponent;